import { inject, injectable } from 'inversify';
import { HttpClientInterface } from '../http/httpClientInterface';
import { OutageClientInterface } from './outageClientInterface';
import { AnnouncementCollection, AnnouncementData, Outages } from './types';

/**
 * @inheritdoc
 */
@injectable()
export class OutageClient implements OutageClientInterface {
  constructor (@inject('OutageHttpClient') private httpClient: HttpClientInterface) { }

  /**
   * @inheritdoc
   */
  public async fetchOutages (): Promise<Outages> {
    const url = 'outage-list';

    const response = await this.httpClient.get<Outages>(url);
    console.log('ff', response);
    return response;
  }

  /**
   * @inheritdoc
   */
  public async fetchAnnouncements (): Promise<AnnouncementData[]> {
    const url = 'announcements?display=web';

    const response = await this.httpClient.get<AnnouncementCollection>(url);
    // API can return data as array directly or wrapped in hydra:member
    const data = response.data;
    if (Array.isArray(data)) {
      return data;
    }
    return data['hydra:member'] ?? [];
  }
}
